// extracted by mini-css-extract-plugin
export default {"socialMediaLinks":"SocialMediaLinks_socialMediaLinks__la8xC","socialLink":"SocialMediaLinks_socialLink__Z2qRH"};